import type { TRPCClientError } from "@trpc/client";
import { DiamondMinus } from "lucide-react";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "./ui/empty";

export default function TaskListNotFoundCallback({ error }: { error: TRPCClientError<any> }) {
    if (error.data?.code === "NOT_FOUND" || error.data?.code === "UNAUTHORIZED") {
        return (
            <div className="h-full">
                <Empty className="h-full">
                    <EmptyHeader>
                        <EmptyMedia variant="icon" className="bg-red-100/60 text-red-600">
                            <DiamondMinus />
                        </EmptyMedia>
                        <EmptyTitle>Task list not found</EmptyTitle>
                        <EmptyDescription>
                            The task list you are looking for does not exist, has been deleted or you are not allowed to
                            view it.
                        </EmptyDescription>
                    </EmptyHeader>
                </Empty>
            </div>
        );
    }
}
